import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33810400&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=33810400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33810400",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseUiModalVideo: require('/var/www/html/intelli.com.br/components/base/ui/ModalVideo.vue').default,BaseUiBreadcrumb: require('/var/www/html/intelli.com.br/components/base/ui/Breadcrumb.vue').default,BaseUiTimeline: require('/var/www/html/intelli.com.br/components/base/ui/Timeline.vue').default,BaseUiGallery: require('/var/www/html/intelli.com.br/components/base/ui/Gallery.vue').default,BaseUiCardBoard: require('/var/www/html/intelli.com.br/components/base/ui/CardBoard.vue').default,BaseUiSlideIt: require('/var/www/html/intelli.com.br/components/base/ui/SlideIt.vue').default})
